type Callback = (evt: Event) => void;

export class Evt {
  listeners: Record<string, Callback[]> = {};
  attach(type: string, callback: Callback) {
    if (!(type in this.listeners)) {
      this.listeners[type] = [];
    }
    this.listeners[type].push(callback);
  }
  detach(type: string, callback: Callback) {
    if (!(type in this.listeners)) {
      return;
    }
    const stack = this.listeners[type];
    // tslint:disable-next-line one-variable-per-declaration
    for (let i = 0, l = stack.length; i < l; i++) {
      if (stack[i] === callback) {
        stack.splice(i, 1);
        return;
      }
    }
  }
  clear(type: string) {
    delete this.listeners[type];
  }
  emit(event: Event) {
    if (!(event.type in this.listeners)) {
      return true;
    }
    const stack = this.listeners[event.type].slice();
    // tslint:disable-next-line one-variable-per-declaration
    for (let i = 0, l = stack.length; i < l; i++) {
      stack[i].call(this, event);
    }
    return !event.defaultPrevented;
  }
}
